import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '@/components/admin/AdminSidebar';
import AdminProjectDetail from '@/components/admin/AdminProjectDetail';
import AdminProjectFormNew from '@/components/admin/AdminProjectFormNew';
import AdminUnitForm from '@/components/admin/AdminUnitForm';
import AdminInvestorsTab from '@/components/admin/AdminInvestorsTab';
import AdminBrokersTab from '@/components/admin/AdminBrokersTab';
import AdminTransactionsTab from '@/components/admin/AdminTransactionsTab';
import AdminUnitLifecycle from '@/components/admin/AdminUnitLifecycle';
import AdminUnitDetailView from '@/components/admin/AdminUnitDetailView';
import AdminPropertiesTab from '@/components/admin/AdminPropertiesTab';
import AdminSettings from '@/components/admin/AdminSettings';
import OperationsConsole from '@/components/admin/OperationsConsole';
import FinancialLedger from '@/components/admin/FinancialLedger';
import AdminAnalyticsDashboard from '@/components/admin/AdminAnalyticsDashboard';
export default function AdminDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [addingUnitToProject, setAddingUnitToProject] = useState(null);
  const [addingProperty, setAddingProperty] = useState(false);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [unitDetailId, setUnitDetailId] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  const handleViewUnit = (unitId) => {
    setSelectedUnitId(unitId);
  };

  const handleViewUnitDetail = (unitId) => {
    setUnitDetailId(unitId);
  };

  const renderContent = () => {
    // Unit detail view (valuation, secondary market controls)
    if (unitDetailId) {
      return <AdminUnitDetailView 
        unitId={unitDetailId} 
        onBack={() => {
          setUnitDetailId(null);
          // Go back to project detail if we came from there
          if (selectedProjectId) {
            // Keep selectedProjectId so we return to that project
          }
        }} 
      />;
    }
    
    // Unit lifecycle view
    if (selectedUnitId) {
      return <AdminUnitLifecycle 
        unitId={selectedUnitId} 
        onBack={() => setSelectedUnitId(null)} 
      />;
    }
    
    if (addingUnitToProject) {
      return <AdminUnitForm projectId={addingUnitToProject} onBack={() => {
        setAddingUnitToProject(null);
        setSelectedProjectId(addingUnitToProject);
      }} />;
    }
    
    // Adding new property - inline form
    if (addingProperty) {
      return <AdminProjectFormNew onBack={() => setAddingProperty(false)} onSuccess={(projectId) => {
        setAddingProperty(false);
        setSelectedProjectId(projectId);
      }} />;
    }
    
    if (selectedProjectId) {
      return <AdminProjectDetail 
        projectId={selectedProjectId} 
        onBack={() => setSelectedProjectId(null)} 
        onAddUnit={(pid) => setAddingUnitToProject(pid)}
        onViewUnitLifecycle={(unitId) => setSelectedUnitId(unitId)}
        onViewUnitDetail={(unitId) => setUnitDetailId(unitId)}
      />;
    }

    switch(activeTab) {
      case 'dashboard':
        return <AdminAnalyticsDashboard />;
      case 'operations':
        return <OperationsConsole onViewUnit={handleViewUnit} onViewUnitDetail={handleViewUnitDetail} />;
      case 'ledger':
        return <FinancialLedger />;
      case 'properties':
        return <AdminPropertiesTab 
          onAddNew={() => setAddingProperty(true)} 
          onViewProject={(pid) => setSelectedProjectId(pid)} 
        />;
      case 'investors':
        return <AdminInvestorsTab />;
      case 'brokers':
        return <AdminBrokersTab />;
      case 'transactions':
        return <AdminTransactionsTab />;
      case 'settings':
        return <AdminSettings />;
      default:
        return <AdminAnalyticsDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-black flex">
      <AdminSidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        setSelectedUnitId={setSelectedUnitId}
        setSelectedProjectId={setSelectedProjectId}
        onLogout={handleLogout} 
      />
      <main className="flex-1 ml-64">
        {renderContent()}
      </main>
    </div>
  );
}
